import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NumberPipe } from '../../../shared/pipes/number.pipe';

@Component({
  selector: 'app-sponsor-cards',
  standalone: true,
  imports: [CommonModule, NumberPipe],
  templateUrl: './sponsor-cards.component.html',
  styleUrl: './sponsor-cards.component.scss'
})
export class SponsorCardsComponent implements OnInit, OnChanges {
  @Input() protocolForecastData: any;
  formattedRemainingBudget = '$0';
  formattedSavings = '$0';

  ngOnInit() {
    this.updateValues();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.protocolForecastData && this.protocolForecastData) {
      this.updateValues();
    }
  }

  private updateValues(): void {
    const remainingBudget = this.protocolForecastData?.remainingBudget || 0;
    const savings = this.protocolForecastData?.savings || 0;

    const numberPipe = new NumberPipe();
    this.formattedRemainingBudget = `$${numberPipe.transform(remainingBudget)}`;
    this.formattedSavings = `$${numberPipe.transform(savings)}`;
  }
}
